/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Templates_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs */

const en_forms_templates_settings_phone_is_user_allowed_to_access_camera_settings = /** @type {(inputs: Forms_Templates_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const de_forms_templates_settings_phone_is_user_allowed_to_access_camera_settings = /** @type {(inputs: Forms_Templates_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Forms_Templates_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_templates_settings_phone_is_user_allowed_to_access_camera_settings = /** @type {((inputs?: Forms_Templates_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Templates_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_templates_settings_phone_is_user_allowed_to_access_camera_settings(inputs)
	return de_forms_templates_settings_phone_is_user_allowed_to_access_camera_settings(inputs)
});